query ProductLine(
    $id: ID!
) {
    productLine(id: $id) {
        id

        brandID
        key

        name {
            language
            text
        }

        image

        parameterIDs
    }
}
